
import store from '@/store/index'

export default function auth({ to, next }) {
    const loginQuery = { path: "/login", query: { redirect: to.fullPath } };
  
    if (store.getters.isLoggedIn) {

      next();
       
      } 
       else {
        next(loginQuery);
      }
  }
